// extracted by mini-css-extract-plugin
export default {"lightboxContent":"ArticleImageLightbox_lightboxContent__Qq9gb","lightboxBody":"ArticleImageLightbox_lightboxBody__vY5+q","lightboxImage":"ArticleImageLightbox_lightboxImage__M7Yr5"};